<!-- 选择学员-多选 -->
<template>
  <el-form-item :label="label">
    <el-select v-model="studentMultiple" :multiple="config.multiple === false ? false : true" filterable remote
      reserve-keyword collapse-tags-tooltip fit-input-width :collapse-tags="true" :max-collapse-tags="1" clearable
      automatic-dropdown :placeholder="config.placeholder" :remote-method="remoteMethod" :loading="loading"
      @visible-change="clearStudentData">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref } from 'vue';

export default {
  kind: 'yq-支持多选学员选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ([]),
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '学员：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    const api = inject('api');
    const loading = ref(false);

    const options = ref([]);
    const remoteMethod = async (query) => {
      loading.value = true;
      const { data } = await api.getStudentList({
        queryKey: query,
        displayHistory:
          false,
        intentionStatus: '',
        scene: 0,
        campusIds: [],
        page: { pageNum: 0, pageSize: 100 },
      }).finally(() => {
        loading.value = false;
      });
      options.value = data.map((v) => ({ label: v.name, value: v.id }));
    };
    remoteMethod('');
    const clearStudentData = (val) => {
      if (!val) {
        remoteMethod('');
      }
    };
    // eslint-disable-next-line no-use-before-define
    const studentMultiple = useQuery('students', props.value, reset);
    function reset() {
      studentMultiple.value = props.value;
    }
    if (props.value.id) {
      onMounted(() => {
        child.value.setField(props.value.name);
      });
    }

    return {
      child,
      reset,
      studentMultiple,
      loading,
      remoteMethod,
      clearStudentData,
      options,
    };
  },
};
</script>
